import request from '@/service/request'

export default class ajaxAuthService {
  static login(data: any): Promise<any> {
    return request.post('/login', data)
  }
  static getUserInfo(): Promise<any> {
    return request.get('/login/userInfo')
  }
  static logOut(): Promise<any> {
    return request.get('/logout')
  }
  static getProtocol(data:any): Promise<any> {
    return request.get('/protocol/detail',data)
  }
  static readProtocol(data:any): Promise<any> {
    return request.post('/protocol/record',data)
  }
}
